import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import moment from "moment";

// Components
import { CustomerButton } from "../../Component/Button";
import { DateRangePicker, LocationPicker } from "../../Component/BookingBase";

// Redux
import { ListLocation } from "../../../Redux/Location";

//Translation
import { useTranslation } from "react-i18next";
import svg_icon from "../../../Assets/svg_icon";
import { momentDateTimeFormat } from "../../../utils";

const Banner = () => {
  // State
  const [error, setError] = useState({
    pickUpLocation: undefined,
    dropOffLocation: undefined,
    time: undefined,
    common: undefined,
  });
  const [pickUpLocation, setPickUpLocation] = useState();
  const [dropOffLocation, setDropOffLocation] = useState();
  const [pickUpDate, setPickUpDate] = useState(null);
  const [dropOffDate, setDropOffDate] = useState(null);
  const [top, setTop] = useState(null);

  // Selector
  const { pickUpList, dropOffList } = useSelector((state) => state.location);

  const { booking } = useSelector((state) => state.setting);

  // Use
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (pickUpList === undefined) dispatch(ListLocation("PICKUP"));
    if (dropOffList === undefined) dispatch(ListLocation("DROPOFF"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const pickUpLocationRef = useRef();
  useEffect(() => {
    if (!pickUpLocationRef?.current?.offsetTop) {
      return;
    }
    setTop(pickUpLocationRef?.current?.offsetTop);
    const handleWindowResize = () => {
      if (window.innerWidth < 1400) {
        setTop(pickUpLocationRef?.current?.offsetTop);
      }
    };

    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  });

  const searchHandler = () => {
    let flag = 0,
      err = {
        pickUpLocation: undefined,
        dropOffLocation: undefined,
        time: undefined,
        common: undefined,
      };

    if (pickUpLocation === undefined) {
      err["pickUpLocation"] = "Please select a pick-up location";
      flag = 1;
    } else {
      err["pickUpLocation"] = undefined;
    }
    if (dropOffLocation === undefined) {
      err["dropOffLocation"] = "Please select a drop-off location";
      flag = 1;
    } else {
      err["dropOffLocation"] = undefined;
    }
    // Time Error
    if (pickUpDate === null || dropOffDate === null) {
      err["time"] = "Please select appropriate time";
      flag = 1;
    } else {
      err["time"] = undefined;
    }

    if (flag == 0) {
      let temp = moment(dropOffDate, momentDateTimeFormat).diff(
        moment(pickUpDate, momentDateTimeFormat),
        "day"
      );
      if (temp > booking?.day?.max)
        err["common"] = `${t("error.maximumBooking")} ${booking?.day?.max} ${t(
          "labels.days"
        )}`;
      else if (temp < booking?.day?.min)
        err["common"] = `${t("error.minimumBooking")} ${booking?.day?.min} ${
          booking?.day?.min <= 1 ? t("labels.perDay") : t("labels.days")
        }`;
      else {
        setError({
          pickUpLocation: undefined,
          dropOffLocation: undefined,
          time: undefined,
          common: undefined,
        });
        navigate(
          `/search/${btoa(
            encodeURI(
              JSON.stringify({
                pickUpLocation,
                dropOffLocation,
                pickUpDate,
                dropOffDate,
              })
            )
          )}/undefined`
        );
      }
      setError(err);
    } else setError(err);

    if (!pickUpLocation || !dropOffLocation || !pickUpDate || !dropOffDate) {
      if (window.innerWidth < 1400)
        window.scrollTo({
          top: top - 70,
          behavior: "smooth",
        });
    }
  };

  return (
    <div className="banner_section d-md-block">
      <div className="banner_section_background d-md-flex align-items-md-center">
        <div className="container">
          <h4 className="ff_bd f38 bannerSectionHeading txt-primary pt-4 pt-md-0 mt-md-2">
            {t("customer.homePage.headers.instantBook")}
          </h4>
          <p className="ff_rg f14 mb-3 mb-xl-4" style={{ maxWidth: "520px" }}>
            {t("customer.homePage.subHeaders.joinInstant")}
          </p>

          <div
            className="bg-white shadow-sm rounded px-4 py-4 px-xl-5 py-xl-5 banner-select-option col-12 col-md-5 col-lg-6 col-xl-7 col-xxl-8 position-relative pb-5"
            ref={pickUpLocationRef}
          >
            <h4 className="f20 ff_bd txt-primary">
              {t("customer.homePage.formTitle.rentCar")}
            </h4>
            <div className="row">
              <LocationPicker
                nameOfClass={"col-12 col-md-12 col-xxl-6"}
                label={t("customer.homePage.labels.pickUpLoc")}
                locationList={pickUpList}
                uid={"pickUpLocation"}
                locationId={pickUpLocation}
                setLocationId={setPickUpLocation}
                placeholderText={t(
                  "customer.homePage.defaultFormInput.choosePickUp"
                )}
                error={error}
                setError={setError}
              />
              <LocationPicker
                nameOfClass={"col-12 col-md-12 col-xxl-6"}
                label={t("customer.homePage.labels.dropOffLoc")}
                locationList={dropOffList}
                uid={"dropOffLocation"}
                locationId={dropOffLocation}
                setLocationId={setDropOffLocation}
                placeholderText={t(
                  "customer.homePage.defaultFormInput.chooseDropOff"
                )}
                error={error}
                setError={setError}
              />

              <div className="col-12 col-md-12 col-lg-12 col-xxl-6">
                <DateRangePicker
                  nameOfClass={"col-12 col-md-12 col-lg-12 col-xxl-12"}
                  label={t("customer.homePage.labels.pickAndReturnDate")}
                  startDate={pickUpDate}
                  setStartDate={setPickUpDate}
                  endDate={dropOffDate}
                  setEndDate={setDropOffDate}
                />
                <span className="small text-danger error-message mt-1 d-xxl-none">
                  {!pickUpDate && !dropOffDate && t(error?.common)}
                  {!pickUpDate && !dropOffDate && t(error?.time)}&nbsp;
                </span>
              </div>

              <div className="col-12 col-md-12 col-xxl-6 align-self-end mt-2 mt-xxl-0 ">
                <CustomerButton
                  nameOfClass="c-primary px-5 h54 c-primary border-n px-5"
                  pressHandler={searchHandler}
                >
                  {svg_icon?.search}
                </CustomerButton>
              </div>

              <span className="small text-danger error-message mt-1 d-none d-xxl-block">
                {!pickUpDate && !dropOffDate && t(error?.common)}
                {!pickUpDate && !dropOffDate && t(error?.time)}&nbsp;
              </span>
            </div>

            <div className="discount-message position-absolute bottom-0 start-0 p-2 w-100 c-secondary">
              Renting for over 2 weeks earns an average discount of{" "}
              {booking?.discount?.[0]?.percentage || 0}%.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
